import Apirest from '../../Content/Apirest';

/**
 * Load available tags from organization users and participants.
 * Normalizes to lowercase strings and removes duplicates and empty entries.
 */
export function loadAvailableTags(callback: (tags: string[]) => void) {
    Apirest.get_organization_users((users: any[]) => {
        Apirest.get_participants((participants: any[]) => {
            const raw = [
                ...users.flatMap((u: any) => u.tags || []),
                ...participants.flatMap((p: any) => p.tags || [])
            ];

            const tags = raw
                .filter((item: any) => typeof item === 'string' && item !== '')
                .map((t: string) => t.toLowerCase())
                .filter((item: string, i: number, ar: string[]) => ar.indexOf(item) === i);

            callback(tags);
        });
    });
}

export default loadAvailableTags;
